module.exports = __webpack_public_path__ + "static/appStore-13ca2c12a85f14e38c768b32376b3eb3.svg";